module.exports = __webpack_public_path__ + "img/title_reserve.3f447231.png";